<template>
  <Teleport to="body">
    <transition
      mode="out-in"
      enter-active-class="animate__animated animate__faster animate__fadeIn"
      leave-active-class="animate__animated animate__faster animate__fadeOut"
    >
      <div
        class="fixed top-0 z-20 h-full w-full bg-black/40"
        v-if="modelValue"
      />
    </transition>
  </Teleport>
  <Teleport to="body">
    <transition
      mode="out-in"
      enter-active-class="animate__animated animate__faster animate__backInUp"
      leave-active-class="animate__animated animate__faster animate__backOutDown"
    >
      <div
        class="fixed top-0 z-30 flex h-full max-h-dvh w-full items-center justify-center justify-items-center p-5 overflow-scroll"
        v-if="modelValue"
        @click="onOutExit"
      >
        <div
          :class="`rounded-md relative w-fit h-fit flex max-h-full overflow-scroll ${
            containerClass ? containerClass : ''
          }`"
          @click.stop
        >
          <slot></slot>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>
export default {
  name: "new-modal",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    skipOutExit: {
      type: Boolean,
      default: false,
    },
    containerClass: {
      type: String,
    },
  },
  methods: {
    onOutExit() {
      if (!this.skipOutExit) this.$emit("update:modelValue", false);
    },
  },
  emits: ["update:modelValue"],
};
</script>
